import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ClassDetailsPage from '../Tenant-Admin/Class-Manager/pages/ClassDetailsPage';
import HODHeader from './components/Header';

const HODClassDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get data from location state or localStorage
  const tenantId = location.state?.tenantId || localStorage.getItem('tenantId');
  const userId = location.state?.userId || localStorage.getItem('userId');
  const token = localStorage.getItem('token');
  
  // Redirect if no tenant or user
  useEffect(() => {
    if (!tenantId || !userId || !token) {
      navigate('/hod/dashboard');
    }
  }, [tenantId, userId, token, navigate]);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-gray-900">
      <HODHeader />
      <div className="p-4 sm:p-6 lg:p-8">
        {/* ✅ Pass skipLayout={true} to avoid TenantAdminLayout */}
        <ClassDetailsPage 
          location={location} 
          skipLayout={true}
        />
      </div>
    </div>
  );
};

export default HODClassDetails;